import React from "react";

export const Blog = () =>{
    return (
        <iframe title="blog" src="https://apda.ghost.io" style={{position:'fixed',top:'100px',bottom:'0',left:'300',right:'0',height:'100%',width:'100%',border:'none'}}/>
    )
}

export default Blog;